import React from "react";
import CookieConsent from "react-cookie-consent";
import siteConfig from "../siteConfig";
import brand from "../brand";

function CookieConsentModule() {
  return (
    <div>
      <CookieConsent
        disableStyles
        location="none"
        containerClasses="cookie-consent-banner"
        contentClasses="cookie-consent-content"
        buttonWrapperClasses="cookie-consent-actions"
        buttonClasses="btn btn-primary cookie-consent-btn"
        declineButtonClasses="btn btn-outline cookie-consent-btn"
        buttonText="Accept"
        enableDeclineButton
        declineButtonText="Decline"
        cookieName="ChandraIndustries-VCS"
        expires={150}
      >
        {brand.siteName} uses cookies to enhance your experience and enable core site functionality.
        Choose Accept to allow all cookies, or Decline to continue with only what's essential.{" "}
        <a href={siteConfig.legalUrl} target="_blank" rel="noopener noreferrer">
          Learn more.
        </a>
      </CookieConsent>
    </div>
  );
}

export default CookieConsentModule;